document.addEventListener('DOMContentLoaded', function() {
    // Initialize thumbnail swiper
    const thumbsSwiper = new Swiper('.product-media-thumbs', {
      spaceBetween: 8,
      slidesPerView: 4.5,
      freeMode: true,
      watchSlidesProgress: true,
      breakpoints: {
        640: {
          slidesPerView: 4.5,
        },
        768: {
          slidesPerView: 4.5,
        },
        1024: {
          slidesPerView: 5,
        },
      }
    });

    // Initialize main swiper
    const mediaSwiperEl = document.querySelector('.product-media-swiper');
    const mainSwiper = new Swiper('.product-media-swiper', {
      spaceBetween: 8,
      freeMode: {
        enabled: true,
        momentum: true,
        momentumRatio: 1,
        momentumBounce: false,
      },
      grabCursor: true,
      navigation: {
         nextEl: mediaSwiperEl.querySelector('.swiper-button-next'),
         prevEl: mediaSwiperEl.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      thumbs: {
        swiper: thumbsSwiper,
      },
      loop: false,
      keyboard: {
        enabled: true,
      },
      mousewheel: {
        forceToAxis: true,
      },
    });

    // Simple function to slide to variant image (no reordering, just slide)
    function slideToVariantImage(variantId) {
      if (!variantId || !mainSwiper) return;
      
      const slides = document.querySelectorAll('.product-media-swiper .swiper-slide');
      
      slides.forEach((slide, index) => {
        const variantIds = slide.getAttribute('data-variant-ids');
        if (variantIds && variantIds.includes(variantId)) {
          mainSwiper.slideTo(index, 300); // Slide with 300ms animation
        }
      });
    }

    // Method 1: Listen for Dawn's variant change event
    document.addEventListener('variant:change', function(event) {
      if (event.detail && event.detail.variant && event.detail.variant.id) {
        slideToVariantImage(event.detail.variant.id);
      }
    });

    // Method 2: Monitor variant selects (Dawn 2.0+)
    const variantSelects = document.querySelector('variant-selects');
    if (variantSelects) {
      const observer = new MutationObserver(function(mutations) {
        const currentVariant = variantSelects.currentVariant;
        if (currentVariant && currentVariant.id) {
          slideToVariantImage(currentVariant.id);
        }
      });
      
      observer.observe(variantSelects, { 
        attributes: true, 
        subtree: true,
        childList: true
      });
    }

    // Method 3: Listen for variant radio changes
    const variantRadios = document.querySelector('variant-radios');
    if (variantRadios) {
      variantRadios.addEventListener('change', function() {
        setTimeout(function() {
          const currentVariant = variantRadios.currentVariant;
          if (currentVariant && currentVariant.id) {
            slideToVariantImage(currentVariant.id);
          }
        }, 50);
      });
    }

    // Method 4: Listen for form changes (fallback)
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      const variantIdInput = productForm.querySelector('input[name="id"]');
      
      if (variantIdInput) {
        const formObserver = new MutationObserver(function() {
          const variantId = variantIdInput.value;
          if (variantId) {
            slideToVariantImage(variantId);
          }
        });
        
        formObserver.observe(variantIdInput, {
          attributes: true,
          attributeFilter: ['value']
        });
      }
      
      productForm.addEventListener('change', function(event) {
        if (event.target.name && (event.target.name.includes('options') || event.target.name === 'id')) {
          setTimeout(function() {
            const variantId = productForm.querySelector('input[name="id"]')?.value;
            if (variantId) {
              slideToVariantImage(variantId);
            }
          }, 100);
        }
      });
    }
  });